module.exports = __webpack_public_path__ + "static/media/Castlecomer-AlloftheNoise.2000b422.jpg";